// ../../packages/build/src/injections/dev.js
var __DEV__ = process.env.NODE_ENV !== "production";

// src/constants.ts
var SENDER = "reset";

// src/index.ts
import {
  clone,
  overwrite
} from "@harlem/utilities";
var snapshots = new Map();
var eventEmitter;
var stores;
function reset(name, branchCallback) {
  if (!eventEmitter || !stores) {
    throw new Error("Please ensure the reset plugin is registered before resetting a store");
  }
  const snapshot = snapshots.get(name);
  const store = stores.get(name);
  if (!(store && snapshot)) {
    throw new Error("Failed to reset store. Store does not exists or has an invalid snapshot.");
  }
  store.write("plugin:reset:reset", SENDER, (state) => {
    const branchProducer = branchCallback || ((state2) => state2);
    const snapshotClone = clone(snapshot);
    const stateBranch = branchProducer(state);
    const snapshotBranch = branchProducer(snapshotClone);
    overwrite(stateBranch, snapshotBranch);
  });
}
function createResetPlugin() {
  return {
    name: "reset",
    install(app, _eventEmitter, _stores) {
      eventEmitter = _eventEmitter;
      stores = _stores;
      eventEmitter.on("store:created", (payload) => {
        if (!payload) {
          return;
        }
        snapshots.set(payload.store, clone(payload.data));
      });
    }
  };
}
export {
  createResetPlugin as default,
  reset
};
//# sourceMappingURL=harlem-reset.bundler.esm.js.map
